import React, { useEffect, useRef, useState } from "react";

const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);

const AnimatedCounter = ({
  value = 0,
  duration = 1600,
  prefix = "",
  suffix = "",
  decimals = 0,
  className = "",
  "data-testid": testId,
}) => {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            const start = performance.now();
            const step = (now) => {
              const t = Math.min(1, (now - start) / duration);
              setDisplay(value * easeOutCubic(t));
              if (t < 1) requestAnimationFrame(step);
              else setDisplay(value);
            };
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.4 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [value, duration]);

  const formatted =
    decimals > 0 ? display.toFixed(decimals) : Math.round(display).toLocaleString("en-IN");

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};

export default AnimatedCounter;
